module.exports = __webpack_public_path__ + "12f0d6f29c8d6742308c3084edd5ca08.svg";